import React from "react";
import MaterialIcon from "./MaterialIcon";

const ButtonActionIcon = ({ type, size = "sm", onClick, style, className = "", title = "" }) => {
  const buttonStyle = {
    xxsm: {
      width: "16px",
      height: "16px",
      fontSize: "12px"
    },
    xsm: {
      width: "20px",
      height: "20px",
      fontSize: "14px"
    },
    sm: {
      width: "24px",
      height: "24px",
      fontSize: "16px"
    },
    md: {
      width: "32px",
      height: "32px",
      fontSize: "20px"
    },
    lg: {
      width: "40px",
      height: "40px",
      fontSize: "24px"
    }
  };
  return (
    <button
      onClick={onClick}
      style={{ ...style, ...buttonStyle[size] }}
      className={`builder_action_btn ${className} ${type}`}
      title={title}
    >
      <MaterialIcon name={type} style={{ fontSize: buttonStyle[size].fontSize }} />
    </button>
  );
};

export default ButtonActionIcon;
